import React from "react";
import { Box, Stack } from "@mui/material";
import SteminpeLeaderboardTopPlaySchool from "../../components/leaderboards/SteminpeLeaderboardTopPlaySchool";

// http://localhost:3001/steminpe/leaderboard/school-play-duration


const SteamTopPlaySchoolLeaderboard = () => (
    <Box>
        <SteminpeLeaderboardTopPlaySchool />
    </Box>
    // <Box
    //     sx={{
    //         minHeight: "100vh",
    //         display: "flex",
    //         alignItems: "center",
    //         justifyContent: "center",
    //         textAlign: "center",
    //         bgcolor: "background.default",
    //         color: "text.primary",
    //     }}
    // >
        // <SteminpeLeaderboardTopPlaySchool />
    // </Box>
);

export default SteamTopPlaySchoolLeaderboard;